import { ComponentProps, ComponentType } from 'react';
import styled, { css } from 'styled-components';

import MenuLogo from '@r1-frontend/entities/Layout/_deps/components/MenuLogo';
import { CitySelect } from '@r1-frontend/entities/Layout/Header/commonComponents/CitySelect';
import { IImageProps } from '@r1-frontend/entities/Layout/Header/desktop/components/UnauthDesktopHeader/connectionButtonAnimation';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const TOP_WRAPPER_HEIGHT = 40;
export const MAIN_WRAPPER_HEIGHT = 65;

export const Wrapper = styled.div`
    display: block;
    position: relative;
    width: inherit;
    background-color: ${COLORS.BgMain};
    z-index: 11;
    transition: background-color 0.25s ease 0s, top 0.2s ease-out;

    @media (max-width: ${wideBreakpoints.laptop}) {
        display: none;
        height: 0;
    }
`;

export const Container: ComponentType<ComponentProps<typeof WideContainer>> = styled(WideContainer)`
    align-items: flex-start;
    justify-content: space-between;
`;

const commonWrapperWithIndentStyle = css`
    width: inherit;
    background-color: ${COLORS.BgMain};

    > :first-child {
        width: inherit;
        height: inherit;
        background-color: inherit;
        position: fixed;
    }
`;

export const MainWrapperOffset = styled.div`
    ${commonWrapperWithIndentStyle};

    height: ${MAIN_WRAPPER_HEIGHT}px;
`;

export const TopWrapperOffset = styled.div<{ isScrollingUp: boolean }>`
    ${commonWrapperWithIndentStyle};
    
    height: ${p => p.isScrollingUp ? `${TOP_WRAPPER_HEIGHT}px` : '0'};
    transition: height .25s;
`;

export const TopWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const CitySelectionBlock = styled(CitySelect)<{ isAuth?: boolean }>`
    position: relative;
    margin-right: auto;
    transition: color .25s;

    ${({ isAuth }) =>
        isAuth &&
            `
              visibility: hidden;
              pointer-events: none;
            `
    }
`;

export const PartnersBlock = styled.ul`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    flex: 1 1 auto;
    justify-content: center;
    padding-top: 12px;
`;

export const ServiceBlock = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`;

export const MainWrapper = styled.nav`
    display: flex;
    flex-wrap: nowrap;
    padding-top: 15px;
    border-bottom: 1px solid ${COLORS.Outline_Light};
`;

export const LogoBlock = styled.div`
    align-items: baseline;
    margin-right: 10px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-right: 6px;
    }
`;

export const SMenuLogo = styled(MenuLogo)`
    margin-top: 4px;

    img {
        max-width: unset;
        height: 26px;
    }
`;

export const MainBlockInnerContainer = styled.ul`
    display: flex;
    flex: 1;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: baseline;
`;

export const ClientActionsBlock = styled.div`
    display: flex;
    position: relative;
    flex-wrap: nowrap;
    align-items: baseline;
    margin-left: 10px;

    & > div {
      margin-left: 8px;
    }
  
    & > a:not(:first-child),
    & > button:not(:first-child) {
        margin-left: 12px;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-left: 6px;
    }
`;

export const AnimationImg = styled.div<IImageProps>`
    color: ${COLORS.TextWhite};
    ${FONTS.MediumXXS};
    background-color: ${COLORS.Brand_Blue};
    padding: 4px 8px;
    border-radius: ${BorderRadius.labelRadius};
    position: absolute;
    transform: rotate(${p => p.isHover ? `${p.rotateOnLeave}deg` : '0'});
    top: ${p => p.isHover ? `${p.top}px` : '5px'};
    left: ${p => `${p.left}px`};
    right: ${p => `${p.right}px`};
    transition: all .5s ease;
`;

export const SBaseButton = styled(BaseButton)`
    position: relative;
    z-index: 100;
`;
